import {QueryCommand} from "xmgoing-server";
import GoingUtils from "@/utils/goingUtils";

/**
 * 查询用户根据拼音输入
 * @param value
 * @param backFun
 * @constructor
 */
export function QueryUserByPinyin(value:string,backFun,showLoading=true,roleName?:any,queryParams?:any){
  showLoading?GoingUtils.showLoading():'';
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/users/queryUserByPinyin`,
    method: 'GET'
  });
  let params={pinyin: unref(value)};
  if(unref(queryParams)){
    params={...queryParams,...params};
  }
  if(unref(roleName)){
    params['roleName']=unref(roleName);
  }
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询用户集合 根据 用户id集合
 * @param params
 * @param backFun
 * @constructor
 */
export async function QueryUserByIds(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/users/listUserByIds`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询组织机构信息
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryOrgs(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/dept/getOrgsByCurAccountId`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询用户 根据机构id
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryUsersByOrgId(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/users/getUserByOrgId/`+params.orgId,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询角色列表
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryRoles(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/roles/getAllRoleByBelong/unit`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询用户根据角色id
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryUsersByRoleId(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/component/getUserByRoleId/`+params.roleId,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

